import { createApp, defineAsyncComponent, ref, onMounted, inject } from 'vue';

/////////////////////////////////////////////////////////////////////////////////////////////////// PLUGINS
import { createPinia } from 'pinia';
import CookiesBar from './plugins/cookies-bar/index.js';
import Modals from './plugins/modals/index.js';
import Notifications from './plugins/notifications/';
import SiteDrawer from './plugins/site-drawer/index.js';
import Currency from './plugins/currency/index.js';
import PageLoader from './plugins/page-loader/index.js';
// import ScrollTo from './plugins/scroll-to/index.js';

/////////////////////////////////////////////////////////////////////////////////////////////////// COMPONENTS
const OrderHistory = defineAsyncComponent(() => import('./order-history.vue'));
const ProductCodeAdd = defineAsyncComponent(() => import('./product-code-add.vue'));
const PoolForm = defineAsyncComponent(() => import('./pool-form.vue'));
const DefectiveForm = defineAsyncComponent(() => import('./defective-form.vue'));

/////////////////////////////////////////////////////////////////////////////////////////////////// APP
import "bootstrap/js/dist/tab.js";
// import { devices, viewportSize } from './imports/utils';
// import Animations from './animations.js';

createApp({
    // mixins: [Animations],
    components: {
        ProductCodeAdd,
        OrderHistory,
        PoolForm,
        DefectiveForm
    },
    setup() {
        if (process.env.NODE_ENV === 'production') console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;');

        ///////////////////////////////////////////////////////////////////////////// Session modal (DELETE THIS IN PRODUCTION)
        // const $modal = inject('$modal');
        // onMounted(() => {
        //     $modal.show('modal-session');
        // })

        ///////////////////////////////////////////////////////////////////////////// scrollTop
        const scrollTop = ref(0);
        const onScroll = () => {
            scrollTop.value = window.scrollY;
        }
        window.addEventListener("scroll", onScroll, { passive: true });

        const reloadPage = () => {
            window.location.reload();
        };

        ///////////////////////////////////////////////////////////////////////////// viewportSize
        // const viewport = ref(viewportSize());
        // const onResize = () => {
        //     viewport.value = viewportSize();
        // }
        // window.addEventListener("resize", onResize, { passive: true });

        // onMounted(() => {
        //     if (devices()) {
        //         document.getElementsByTagName('html')[0].classList.add('touch-device');
        //     }
        // });

        return {
            assets: `/site/${process.env.MIX_TEMPLATE_FOLDER}/dist`,
            locale: window.Laravel.code,
            scrollTop,
            reloadPage,
            // viewport,
        }
    },
})

    // TODO: remove some components from global scope
    .component('BgImage', defineAsyncComponent(() => import('./components/bg-image/index.vue')))
    .component('Login', defineAsyncComponent(() => import('./login.vue')))
    .component('CartLink', defineAsyncComponent(() => import('./cart-link.vue')))
    .component('SearchProduct', defineAsyncComponent(() => import('./search-product.vue')))
    .component('MainMenu', defineAsyncComponent(() => import('./main-menu.vue')))
    .component('CartList', defineAsyncComponent(() => import('./cart-list.vue')))
    .component('CartCheckout', defineAsyncComponent(() => import('./cart-checkout.vue')))
    .component('ProductsCarousel', defineAsyncComponent(() => import('./products-carousel.vue')))
    .component('ProductsList', defineAsyncComponent(() => import('./products-list.vue')))
    .component('BranchSelectForm', defineAsyncComponent(() => import('./branch-select-form.vue')))
    .component('ProductInnerGallery', defineAsyncComponent(() => import('./product-inner-gallery.vue')))
    .component('ProductInnerCart', defineAsyncComponent(() => import('./product-inner-cart.vue')))
    .use(createPinia())
    .use(CookiesBar)
    .use(Modals)
    .use(Notifications)
    .use(SiteDrawer)
    .use(Currency)
    .use(PageLoader)
    // .use(ScrollTo, {
    //     // debug: true,
    //     headerHeight: 155,
    //     menuSelector: '.page-menu'
    // })
    .mount('#app');
